import { render, staticRenderFns } from "./3D-City.vue?vue&type=template&id=71eb827b"
import script from "./3D-City.vue?vue&type=script&lang=js"
export * from "./3D-City.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports